var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconClose = function SvgIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m13.41 11.625 4.822-4.821a.732.732 0 1 0-1.035-1.036l-4.822 4.822-4.822-4.822a.732.732 0 1 0-1.035 1.036l4.821 4.821-4.821 4.822a.732.732 0 1 0 1.035 1.036l4.822-4.822 4.822 4.822a.732.732 0 1 0 1.035-1.036z"
  })));
};
export default SvgIconClose;